import { useState } from 'react'
import { Dialog } from './Dialog'
import { ChatPage, ChatPageProps } from './ChatPage'
import { HighFive, Player } from '../types'

export interface HighFiveDialogProps extends ChatPageProps {
  teammateName: string
  onCancel: Function
}

const HighFiveDialog = ({
  teammateName,
  onCancel,
  ...props
}: HighFiveDialogProps) => {
  return (
    <Dialog
      title={`Send ${teammateName} a high five! 👋`}
      hasSubmitButton={false}
      closeText="Close"
      onClose={onCancel}
    >
      <ChatPage
        {...props}
      />
    </Dialog>
  )
}

export default HighFiveDialog
